import { createSelector } from 'reselect';
import { FileUploadStatus } from '../enums';
import { getFileInfoState } from './getFileInfoState';
export const isAllUploadSuccess = createSelector([getFileInfoState], (state) => {
    for (let i = 0; i < state.allIds.length; i++) {
        const uploadStatus = state.byId[state.allIds[i]].uploadStatus;
        if (uploadStatus !== FileUploadStatus.SUCCESS && uploadStatus !== FileUploadStatus.CANCELLED) {
            return false;
        }
    }
    return true;
});
//# sourceMappingURL=isAllUploadSuccess.js.map